import React, { useState, useEffect, useRef } from "react";
import CarouselItem from "./CarouselItem";
import CarouselMiniature from "./CarouselMiniature";
export default function CarouselList({
  gallery,
  bar,
  toFullScren,
  fullscreen,
  autoChange,
  closeGallery
}) {
  const [queue, setQueue] = useState(0);
  const [key, setKey] = useState(0); // Agregamos una clave única para forzar el re-renderizado
  const myRef = useRef(null);
  useEffect(() => {

if(autoChange) {
  const timer = setTimeout(() => {
    if (queue === gallery.length - 1) {
      setQueue(0);
    } else {
      setQueue(queue + 1);
    }
    setKey((prevKey) => prevKey + 1); // Cambiamos la clave única para forzar el re-renderizado
  }, 8000);

  // Limpiar el temporizador para evitar fugas de memoria
  return () => clearTimeout(timer);
} else {

}
  }, [queue, gallery]); // Dependencias añadidas: queue y gallery

  const currentGalleryItem = gallery[queue]; // Obtener el elemento actual del carrusel

  const next = () => {
    if (queue === gallery.length - 1) {
      setQueue(0);
    } else {
      setQueue(queue + 1);
    }
    setKey((prevKey) => prevKey + 1); // Forzar el re-renderizado al hacer clic en el botón "next"
  };

  const previous = () => {
    if (queue === 0) {
      setQueue(gallery.length - 1);
    } else {
      setQueue(queue - 1);
    }
    setKey((prevKey) => prevKey + 1); // Forzar el re-renderizado al hacer clic en el botón "previous"
  };




  const [openMiniatures, setOpenMiniatures] = useState(false);

  const openMiniaturesF = () => {
    setOpenMiniatures(!openMiniatures);
  };

  const chooseImg = (a) => {
    setQueue(a)
    setKey((prevKey) => prevKey + 1);
  }
  return (
    <div
      // onMouseDown={handleStart}
      // onTouchStart={handleStart}
      // onMouseMove={handleMove}
      // onTouchMove={handleMove}
      // onMouseUp={handleEnd}
      // onTouchEnd={handleEnd}
      className="carousel-list"
    >
      <button className="closebutton" onClick={() => {
        closeGallery()
      }}>
Cerrar
      </button>
 {/* <button className="carousel-button-fullscreen" onClick={toFullScren}>
        <img
          width="18"
          height="18"
          src="https://img.icons8.com/fluency-systems-filled/96/000000/fullscreen.png"
          alt="fullscreen"
        />
      </button> */}
      <div      className="carousel-list">
      {gallery.map((e, index) => 

<CarouselItem url={e}
key={index}

fullscreen={fullscreen}
/>

    
    )}
      </div>

      {/* {gallery ? (
        <div className={`carousel-miniatures-cont ${fullscreen ? "fullscreen-to-top" : ""}`}>
          {openMiniatures ? (
            <div className="carousel-miniatures-row">
              {gallery.map((item, index) => (
                <CarouselMiniature key={index} {...item} chooseImg={chooseImg} index={index} />
              ))}
            </div>
          ) : (
            <></>
          )}

          <button className="carousel-miniatures-button " onClick={openMiniaturesF}> {openMiniatures ? "›" : "‹"} </button>
        </div>
      ) : (
        <></>
      )} */}

      {/* <div className={`carousel-buttons-cont ${fullscreen ? "fullscreen-to-top" : ""}`} >
        <button onClick={previous} className="carousel-button">
          ‹
        </button>
        <button onClick={next} className="carousel-button">
          ›
        </button>
      </div> */}
    </div>
  );
}
